<template>
  <div class="flex items-center w-full">
    <RouterLink v-if="currentUserStore.isAgent() || teamStore.teamSetupProgress >= 100" to="/settings/account/profile">
      <div class="h-8 w-8 mr-3 rounded-full flex items-center justify-center bg-[#fde68a]">
        {{ currentUserStore.currentUserAccountDetails.username.charAt(0).toUpperCase() }}
      </div>
    </RouterLink>
    <RouterLink v-else to="/settings">
      <RadialProgress
        class="text-white mr-2"
        style="--size: 2rem; font-size: 0.5rem"
        :progress="teamStore.teamSetupProgress"
      />
    </RouterLink>
    <div class="flex flex-col text-left text-sm text-ellipsis overflow-hidden">
      {{ currentUserStore.currentUserAccountDetails.username }}
      <div class="cursor-pointer inline-block text-xs leading-4 font-medium text-slate-400" @click="signOut">
        Sign out
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import RadialProgress from '@/components/shared/RadialProgress.vue';
import { useCurrentUserStore } from '@/stores/currentUser.ts';
import { useTeamStore } from '@/stores/team.ts';

const currentUserStore = useCurrentUserStore();
const teamStore = useTeamStore();

// Methods
function signOut() {
  fetch('/users/sign_out', {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
    },
  })
    .then(() => {})
    .then(() => (window.location.href = '/'));
}
</script>
